module.exports = __webpack_public_path__ + "img/36.cd2f99fd.jpg";